// extracted by mini-css-extract-plugin
export var chip = "_ng-2";
export var chipBody = "_ng-8";
export var chipHeader = "_ng-9";
export var chipWithKind = "_ng-7";
export var icon = "_ng-3";
export var kind = "_ng-a";
export var remove = "_ng-5";
export var removeIcon = "_ng-6";
export var row = "_ng-0";
export var rowHistorical = "_ng-1";
export var text = "_ng-4";